const galleryId = 50;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_103324163.jpg","sh_611274791.jpg","sh_611274782.jpg","sh_658131850.jpg","sh_1426462463.jpg","sh_1755900287.jpg","sh_1410375803.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Crown procedure'));

group = ["sh_1582204063.jpg","sh_1079119931.jpg","sh_1670109205.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Metal crown'));

group = ["sh_697624564.jpg","sh_1552767389.jpg","sh_1670109223.jpg","sh_1669842061.jpg","sh_81081196.jpg","sh_610380740.jpg","sh_1176264496.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Zirconium crown'));

group = ["sh_1309917601.jpg","sh_1494043007.jpg","sh_1426462484.jpg","sh_1494043004.jpg","sh_1555107650.jpg","sh_1582203988.jpg","sh_1673668819.jpg","sh_1829640782.jpg","sh_1829640776.jpg","sh_1829640794.jpg","sh_1829640788.jpg"];
group.forEach((i) => addItemToGroup(i, '4. Implant crown'));

group = ["sh_37324345.jpg","sh_248332981.jpg","sh_137343458.jpg","sh_37324348.jpg"];
group.forEach((i) => addItemToGroup(i, '5. Telescopic crown'));

group = ["sh_1474623641.jpg","sh_1722892198.jpg","sh_1320052235.jpg","sh_1626317926.jpg","sh_1445940398.jpg","sh_1320064796.jpg","sh_1664357800.jpg","sh_1707018262.jpg","sh_1710517849.jpg","sh_1735587245.jpg","sh_1445940392.jpg","sh_1626317923.jpg","sh_1828646300.jpg","sh_130972460.jpg","sh_1418702840.jpg","sh_1449582767.jpg","sh_1493327063.jpg","sh_1565398816.jpg","sh_1574256013.jpg","sh_1625247019.jpg","sh_1634215123.jpg","sh_1706112370.jpg","sh_141072922.jpg","sh_154168115.jpg","sh_1710517918.jpg","sh_1792320169.jpg","sh_1710517900.jpg","sh_1551804836.jpg","sh_1792320175.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = [];
group.forEach((i) => addItemToGroup(i, 'deleted'));

group = ["sh_1645168288.jpg"];
group.forEach((i) => addItemToGroup(i, 'x_new'));

export default items;
